import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

const SETTINGS_KEY = ['site-settings'];

/**
 * Fetch the single site-settings row.
 */
async function fetchSettings() {
  const { data, error } = await supabase
    .from('site_settings')
    .select('*')
    .limit(1)
    .single();
  if (error) throw error;
  return data;
}

/**
 * Public hook — read site settings (cached, stale-while-revalidate).
 */
export function useSiteSettings() {
  return useQuery({
    queryKey: SETTINGS_KEY,
    queryFn: fetchSettings,
    staleTime: 5 * 60 * 1000, // 5 min
    gcTime: 30 * 60 * 1000,
  });
}

/**
 * Admin hook — update site settings.
 */
export function useUpdateSiteSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (updates) => {
      // Get the single row id first
      const { data: current, error: fetchErr } = await supabase
        .from('site_settings')
        .select('id')
        .limit(1)
        .single();
      if (fetchErr) throw fetchErr;

      const { data, error } = await supabase
        .from('site_settings')
        .update(updates)
        .eq('id', current.id)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      qc.setQueryData(SETTINGS_KEY, data);
    },
  });
}
